module.exports = __webpack_public_path__ + "static/media/ResendMail.82d59b56.svg";